<template>
  <div>
  <v-row no-gutters>
    <v-card :height="previewHeightPx"  class="flex-shrink-1 mr-3" :width="settingsCollapsedDelayed ? 130 : 350">
    <v-list
      class="pfcl1619563709"> 
      <v-list-item>
        <v-list-item-icon v-if="!settingsCollapsed"><v-icon>$setup</v-icon></v-list-item-icon>
        <v-list-item-action v-if="settingsCollapsed">
          <action-button class="pfcl1619563700"  icon="$expandRight" @click="settingsCollapsed = !settingsCollapsed" :tooltip="$t('webboxes.expand')" />
        </v-list-item-action>
        <v-list-item-content><v-list-item-title class="title"><span v-if="!settingsCollapsed">{{$t('webboxes.cardSetup')}}</span></v-list-item-title></v-list-item-content>
        <v-list-item-action>
          <v-row no-gutters class="ma-0 pa-0" justify="end">
            <action-button class="pfcl1619563690"  v-if="!settingsCollapsed" icon="$collapseLeft" @click="settingsCollapsed = !settingsCollapsed" :tooltip="$t('webboxes.collapse')" />
            <action-button class="pfcl1619563695"  @click="configure(globalConfig)" icon="$settingsDark" :tooltip="$t('common.configure')" />
          </v-row>
        </v-list-item-action>  
      </v-list-item>
      <transition-group name="list" tag="div">
      <template v-for="(c,i) in cardComponents">
      <v-list-item :key="`${c.value}`" :class="`pfcl${c.value}`" v-if="!c.divider">
        <v-list-item-icon>
          <tooltip-icon v-if="settingsCollapsed" :icon="c.icon" :tooltip="c.title"></tooltip-icon><v-icon v-else>{{c.icon}}</v-icon>
        </v-list-item-icon>
        <v-list-item-content><v-list-item-title><span  v-if="!settingsCollapsed"  :class="{ 'grey--text': c.hidden }">{{c.title}}</span></v-list-item-title></v-list-item-content>
        <v-list-item-action>
          <v-row no-gutters class="ma-0 pa-0" justify="end">
            <action-button  v-if="!settingsCollapsed" @click="downList(i)" icon="$downList" :tooltip="$t('webboxes.moveDown')" :disabled="i == cardComponents.length-1"/>
            <action-button  v-if="!settingsCollapsed" @click="upList(i)" icon="$upList" :tooltip="$t('webboxes.moveUp')" :disabled="i == 0"/>
            <action-button @click="configure(c)" icon="$settings" :tooltip="$t('common.configure')" :disabled="c.hidden"/>
          </v-row>
          </v-list-item-action>
      </v-list-item>
      <template v-else>
      <v-list-item :key="`${c.value}noitemvis`" v-if="i == 0">
        <v-list-item-icon><v-icon color="warning">$warn</v-icon></v-list-item-icon>
        <v-list-item-content><v-list-item-title><span :class="{ 'grey--text': true }">{{$t('common.noItems')}}</span></v-list-item-title></v-list-item-content>
      </v-list-item>  
      <v-divider :key="`${c.value}div`"></v-divider>
      <v-subheader :key="`${c.value}`">{{ c.title }}</v-subheader>
      <v-list-item :key="`${c.value}noiteminvis`" v-if="i == cardComponents.length - 1">
        <v-list-item-icon><v-icon>$empty</v-icon></v-list-item-icon>
        <v-list-item-content><v-list-item-title><span :class="{ 'grey--text': true }">{{$t('common.noItems')}}</span></v-list-item-title></v-list-item-content>
      </v-list-item>
      </template>
      </template>
      </transition-group>
    </v-list>
    </v-card>
    <v-card :height="previewHeightPx" class="flex-grow-1  ml-3 pfcl1619563643">
      <v-card-title>{{$t('webboxes.preview.title')}}</v-card-title>
      <v-card-text>
    <p>{{$t('webboxes.preview.text')}}</p>
      <!-- Cant open data uri in a new window <v-btn text color="secondary" @click="popupPreview"><v-icon>$openInNew</v-icon> Open in a new window</v-btn> -->
      
    <v-range-slider class="pfcl1619563668"  track-color="grey" v-model="previewWidthRange" min="-100" max="100" persistent-hint :hint="$t('webboxes.preview.width', { width: previewWidthPx})"/>
    <iframe class="d-block mx-auto" :id="previewId" v-if="previewCode" :srcdoc="previewCode" :style="previewStyle" />
      </v-card-text>
    <!--
    <action-button  class="pfcl1619563677"  fab color="accent" absolute right bottom small icon="$extendDown" :tooltip="$t('webboxes.preview.extend')" @click="previewHeight+=100" />
    -->
    </v-card>

      
  </v-row>
  <v-row>
  <v-col cols="12">
    <!--
    <v-card>
    <v-card-title><h2 class="text-h4">{{$t('webboxes.code.title')}}</h2></v-card-title>
    <v-card-text>
    <v-tabs v-model="tab">
    <v-tab>{{$t('webboxes.code.js.title')}}</v-tab>
    <v-tab :disabled="!util.hasCustomCSS">{{$t('webboxes.code.css.title')}}</v-tab>
    </v-tabs>
    <v-tabs-items class="mt-2" v-model="tab">
    <v-tab-item>
    <p v-html="$t('webboxes.code.js.text')"></p>
    <code-block language="html" :code="javascriptTemplate" as-text>
    </code-block>
    </v-tab-item>
    <v-tab-item>
    <p>{{$t('webboxes.code.css.text')}}</p>
    <code-block language="css" :code="cssTemplate">
    </code-block>
    </v-tab-item>
    </v-tabs-items>
    </v-card-text>
    </v-card>
    -->
    <component v-bind:is="installComponent" :customCss="util.hasCustomCSS" :js="javascriptTemplate" :css="cssTemplate" :box="name" :backend="isBackendBox"></component> 
  </v-col>
  
  </v-row>
  <v-navigation-drawer app right temporary v-model="configPanel" width="500">
    <v-card elevation="0" v-if="!colorp.picker">
      <v-card-title>{{$t('webboxes.styling.title')}}<v-spacer /><action-button icon="$close" tooltip="Close" @click="configPanel=false"/></v-card-title>
      <global-styling v-if="styling.global" v-bind.sync="JSglobal" :hide="hiddenGlobals"/>
      <text-styling v-if="styling.text" v-bind.sync="CSStext" />
      <image-styling v-if="styling.image" v-bind.sync="JSimage" />
      <v-row no-gutters v-if="styling.color || styling.background">
      <v-col>
      <color-styling v-if="styling.color" v-bind.sync="CSScolor" property="color" :title="$t('webboxes.styling.textColor')" css="color" @pick="openPicker"/>
      </v-col>
      <v-col>
      <color-styling v-if="styling.background" v-bind.sync="CSSbackground" property="background" :title="$t('webboxes.styling.backgroundColor')" css="background-color" @pick="openPicker"/>
      </v-col>
      </v-row>
      <color-styling v-if="styling.button" v-bind.sync="CSSbutton" property="button" :title="$t('webboxes.styling.buttonColor')" css="background-color" @pick="openPicker"/>
      <button-styling v-if="styling.button" v-bind.sync="JSbutton" />
      <sale-styling v-if="styling.sale" v-bind.sync="JSsale" />
      <description-styling v-if="styling.description" v-bind.sync="JSdescription" />
      <block-styling v-if="styling.block" v-bind.sync="CSSblock" />
    <!--
    <web-box-styling @close="configPanel=false" v-bind.sync="styling"/>
    -->
    </v-card>
    <v-card v-else elevation="0">
      <v-card-title>{{$t('webboxes.colors.title')}}</v-card-title>
      <v-card-text>
    <v-color-picker
      width="500"
      dot-size="25"
      mode="hexa"
      show-swatches
      swatches-max-height="500"
      v-model="colorp.selected"
    ></v-color-picker>
      </v-card-text>
    </v-card>
    <template v-slot:append>
        <div class="pa-5">
          <v-btn v-if="!colorp.picker" block color="primary" @click="configPanel=false">{{$t('webboxes.colors.preview')}}</v-btn>
          <v-btn v-else block color="primary" @click="updateColor">{{$t('webboxes.colors.choose')}}</v-btn>
        </div>
      </template> 
  </v-navigation-drawer>
  </div>
</template>
<script>

import CodeTemplates from "@/mixins/web-box-code"
import WebBoxStyling from "@/mixins/web-box-styling"
import CodeBlock from "@/components/CodeBlock"
import {mapGetters} from "vuex"

import WebboxInstallOther from "@/components/web-box-install/Other"
import WebboxInstallShopify from "@/components/web-box-install/Shopify"
export default {
    name: 'WebBoxConfigurator',
    mixins: [CodeTemplates, WebBoxStyling],
    components: {CodeBlock, WebboxInstallOther, WebboxInstallShopify },
    data() {
        return {
          //tab: null,
          previewHeight: 550,
          help: false,
          configPanel: false,
          util: {
            hasHeight: false,
            hasGap: false,
            hasCustomCSS: false
          },
          settingsCollapsed: false,
          settingsCollapsedDelayed: false,
          previewWidth:100,
          previewWidthPx: 0,
          previewCode: this.getPreviewCode(),
          javascriptTemplate: this.getJavascriptTemplate(this.platform),
          b: this.getBoxData()
        };
    },
    props: {
      box: { type: Object, required: true},
      name: { type: String, required: true },
      platform: { type: String, required: true }
      //dirty: Boolean
    },
    watch: {
        box() {
          this. b = this.getBoxData();
          this.updateUtil();
        },
        previewWidthRange() {
          this.previewWidthPx = document.getElementById(this.previewId)?.offsetWidth;
        },
        settingsCollapsed(val) {
          if(val) {
            setTimeout(() => { this.settingsCollapsedDelayed = val; this.setPreviewWidthPx() }, 100);
          } else {
            this.settingsCollapsedDelayed = val;
            this.setPreviewWidthPx();
          }
        },
        configPanel(val) {
          if(!val) {
            this.refreshPreview();
            this.emitUpdate();
          }
        },
    },
    computed: {
      previewId() {
        return `previewif${name}`;
      },
      previewStyle() {
        return {
            width: `${this.previewWidth}%`,
            height: `${this.previewHeight - 200}px`,
            border: '0px'
        }
      },
      previewHeightPx() {
          return `${this.previewHeight}px`;
      },
      savedBoxComponents() {
        return this.cardComponents.slice(0, this.cardComponents.findIndex(i => i.divider)).map(i => i.value);
      },
      previewWidthRange: {
        get() {
          return [-1 * this.previewWidth, this.previewWidth];
        },
        set(val) {
          if(val[0] != this.previewWidth * -1) {
            this.previewWidth = -1 * val[0];
          } else if(val[1] != this.previewWidth) {
            this.previewWidth = val[1];
          }
          if(this.previewWidth < 0) {
            this.previewWidth = -1 * this.previewWidth;
          }
        }
      },
      installComponent() {
        if(this.platform == 'SHOPIFY') {
          return 'WebboxInstallShopify'
        }
        return 'WebboxInstallOther';
      },
      isBackendBox() {
        if(this.platform == 'SHOPTET') {
          return true;
        }
        return false;
      },
      ...mapGetters('ui', ['baseUrl'])
    },
    methods: {
      emitUpdate() {
        let u = JSON.parse(JSON.stringify(this.b));
        u.config = JSON.stringify(u.config); 
        this.$emit('update:box', u);   
      },
      getBoxData() {
        let b = JSON.parse(JSON.stringify(this.box));
        b.config = JSON.parse(b.config);
        return b;
      },
      updateUtil() {
          this.util.hasHeight = !!this.getConfig('image','image','js', 'height');
          this.util.hasGap = this.getConfig('card','global','js','gap') != null;
          this.util.hasCustomCSS = this.getConfig('card','global','js','customCardStyle');
          // update the cardComponents array
          if(this.b.boxComponents && this.b.boxComponents.length > 0) {
            var comps = this.b.boxComponents.map(bc => this.cardComponents.find(cc => cc.value == bc));
            //console.dir(comps);
            var dividerIndex = comps.length;
            comps.push(this.cardComponents.find(c => c.divider == true));
            var cvals = comps.map(c => c.value);
            comps = comps.concat(this.cardComponents.filter(c => !cvals.includes(c.value)));
            this.cardComponents = comps;
            //console.debug(`Divider Index: ${dividerIndex}`);
            this.cardComponents.forEach((c, i) => { c.hidden = i > dividerIndex });
          }
          this.javascriptTemplate = this.getJavascriptTemplate(this.platform);
          // wait for the rest of the page to load...
          setTimeout(() => { 
            this.previewCode = this.getPreviewCode();
            this.setPreviewWidthPx();
          }, 1000);
      },
      
      // https://medium.com/untitled-factory/interactive-ordered-animated-list-in-vue-js-with-vuetify-js-and-nuxt-js-ccf71548f8bf
      downList(index) {
        //console.debug(`UP! ${index}`);
        var a = [...this.cardComponents]
        var tmp = a[index+1];
        if(tmp.divider) {
          a[index].hidden = true;
        }
        if(a[index].divider) {
          tmp.hidden = false;
        }
        //console.dir(tmp);
        a[index+1] = a[index];
        a[index] = tmp;
        this.cardComponents = a;
        this.refreshPreview();
        this.emitUpdate();
      },
      upList(index) {
        this.downList(index-1);
      },

      refreshPreview() {
        this.util.hasHeight = !!this.getConfig('image','image','js', 'height');
        this.util.hasGap = this.getConfig('card','global','js','gap') != null;
        this.util.hasCustomCSS = this.getConfig('card','global','js','customCardStyle');
        // get the current cardsComponents
        this.b.boxComponents = this.savedBoxComponents;
        this.javascriptTemplate = this.getJavascriptTemplate(this.platform);

        this.previewCode = this.getPreviewCode();
        this.setPreviewWidthPx();
      },
      setPreviewWidthPx() {
        // wait for load
        setTimeout(() => { /*console.debug('changing width'); */ this.previewWidthPx = document.getElementById(this.previewId)?.offsetWidth; }, 500);
      },
      /*
      popupPreview() {
        console.debug(this.previewCode);
        window.open(this.previewCode, '_blank', { height: 500, width: 1000});
      },*/
      
      /*
      beforeSave(fields) {
        // this is copy of the original object so we can modify it and do not harm the state of the app
        //console.dir(fields);
        this.$emit('update:dirty', false);
        fields[`${this.box}Box`].config = JSON.stringify(fields[`${this.box}Box`].config); 
      },
      */
    },
    mounted() {
      if(this.box) {
        this.updateUtil();
      }
    }
}
</script>
<style scoped>
.list-move {
  transition: transform 0.5s ease-out;
}

.list-enter, .list-leave-to {
  opacity: 0;
}
.list-enter-active, .list-leave-active {
  transition: opacity 0.5s ease;
}

</style>